import { costShare } from './schedule-cost-split.js';
/** Presentation only: use the exact recorded decimal ratio, never a guessed fraction. */
export function readableRecordedShare(value) {
    try {
        const share = costShare(value);
        if (value.includes('/')) {
            if (share.d <= 1000000n)
                return `${share.n}/${share.d}`;
            return `${new Intl.NumberFormat('en-GB', { maximumFractionDigits: 6 }).format(Number(share.n) * 100 / Number(share.d))}%`;
        }
        return `${value.trim().replace(/%$/, '').replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')}%`;
    }
    catch {
        return value;
    }
}
//# sourceMappingURL=recorded-share.js.map